export default function LoaderSkeletonSimple({ className }: { className: string }): React.ReactElement {
  const backgroundImage = `
    linear-gradient(
        90deg, 
        rgba(255, 255, 255, 0) 0%,
        rgba(255, 255, 255, 0.2) 20%,
        rgba(255, 255, 255, 0.5) 60%,
        rgba(255, 255, 255, 0))
    `

  return (
    <div className={`relative overflow-hidden rounded bg-gray-light ${className}`}>
      <div
        className="absolute inset-0 transform -translate-x-full"
        style={{ backgroundImage, animation: 'shimmer 750ms infinite' }}
      />
    </div>
  )
}
